import React__default from 'react';
import { GlobalTextCopyContextProvider } from '@invitae/cms-blocks';

var GlobalTextCopyProvider = function (_a) {
    var children = _a.children, globalTextCopiesConfig = _a.globalTextCopiesConfig, contentfulConfig = _a.contentfulConfig, countryCode = _a.countryCode;
    var enableClientSideRequest = globalTextCopiesConfig.enableClientSideRequest, textCopies = globalTextCopiesConfig.textCopies;
    return (React__default.createElement(GlobalTextCopyContextProvider, { contentfulConfig: contentfulConfig, countryCode: countryCode, enableClientSideRequest: enableClientSideRequest, textCopies: textCopies }, children));
};

export { GlobalTextCopyProvider as default };
//# sourceMappingURL=GlobalTextCopyProvider.esm.js.map
